import { FooterCopyright, FooterLogo, FooterMain, FooterNavBar, FooterWrapper, LangSwitchFooter, LangSwitchWrapperFooter } from "./Footer.styled";
import { FooterLogoImg } from "../../assets/img/FooterLogoImg";
import { Link } from "react-router-dom";
import { sliderArrowRight } from "../../assets/img/sliderArrowRight";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { changeLang } from "../../store/app/appSlice";
import { useLocation } from "react-router-dom";

export const Footer = () => {
  const [showLangSwitch, setShowLangSwitch] = useState(false);
  const lang = useSelector((state) => state.app.lang);
  const dispatch = useDispatch();
  const location = useLocation();

  let whiteText = location.pathname.includes("/collections/") || location.pathname.includes("/creators/");

  return (
    <FooterWrapper>
      <div className='container'>
        <FooterMain>
          <FooterLogo to='/'>
            <FooterLogoImg />
          </FooterLogo>
          <FooterNavBar>
            <Link to='/marketplace'>Mаrketplаce</Link>
            <Link to='/'>Telegrаm Chаnnel</Link>
            <Link to='/faq'>FАQ</Link>
            <Link to='/privacy-policy'>Privacy Policy</Link>
            <Link to='/terms-of-service'>Terms of Service</Link>
          </FooterNavBar>
          <LangSwitchWrapperFooter showLangSwitch={showLangSwitch}>
            {sliderArrowRight()}
            <LangSwitchFooter whiteText={whiteText} showLangSwitch={showLangSwitch} onClick={() => setShowLangSwitch(!showLangSwitch)}>
              <span className={lang !== "EN" && "hidden"} onClick={() => (dispatch(changeLang("EN")), setShowLangSwitch(false))}>
                English
              </span>
              <span className={lang !== "Укр" && "hidden"} onClick={() => (dispatch(changeLang("Укр")), setShowLangSwitch(false))}>
                Українська
              </span>
              <span className={lang !== "Рус" && "hidden"} onClick={() => (dispatch(changeLang("Рус")), setShowLangSwitch(false))}>
                Русский
              </span>
            </LangSwitchFooter>
          </LangSwitchWrapperFooter>
        </FooterMain>
        <FooterCopyright>© Tontаke, 2022</FooterCopyright>
      </div>
    </FooterWrapper>
  );
};
